import React from 'react'


export default function TractorSpecifications() {
    const showMore = () => {

    }

    const data1 = [
            {
                name: 'No. Of Cylinder',
                value: '3',
            }, {
                name: 'HP Category',
                value: '47 HP',
            }, {
                name: 'Engine Rated RPM',
                value: '2000',
            }, {
                name: 'Capacity CC',
                value: '2761 CC',
            }
        ]
    const data2 = [
            {
                key: '1',
                name: 'John Brown',
                age: 32,
                address: 'New York No. 1 Lake Park',
                tags: ['nice', 'developer'],
            }, {
                key: '2',
                name: 'Jim Green',
                age: 42,
                address: 'London No. 1 Lake Park',
                tags: ['loser'],
            }, {
                key: '3',
                name: 'Joe Black',
                age: 32,
                address: 'Sidney No. 1 Lake Park',
                tags: ['cool', 'teacher'],
            }, {
                key: '2',
                name: 'Jim Green',
                age: 42,
                address: 'London No. 1 Lake Park',
                tags: ['loser'],
            }, {
                key: '3',
                name: 'Joe Black',
                age: 32,
                address: 'Sidney No. 1 Lake Park',
                tags: ['cool', 'teacher'],
            }, {
                key: '2',
                name: 'Jim Green',
                age: 42,
                address: 'London No. 1 Lake Park',
                tags: ['loser'],
            }, {
                key: '3',
                name: 'Joe Black',
                age: 32,
                address: 'Sidney No. 1 Lake Park',
                tags: ['cool', 'teacher'],
            }
        ]


    return (
        <div>
            <div className="mx-3 mb-4 md:ml-0 px-3 py-2 bg-white rounded shadow">
                <div className="mx-3 mb-3">
                    <h1 className="text-2xl font-semibold text-gray-700 border-b border-gray-200">Specifications</h1>
                </div>

                <div className="m-3">
                    <div>
                        <div className="my-2">
                            <p className="text-lg font-semibold text-gray-700 tracking-wide"><u>Engine</u></p>
                        </div>

                        {data1.map((value, key) => (

                            <div key={key} className="my-4">
                                <div className="grid grid-cols-3">
                                    <div className="col-span-1">
                                        <p className="text-gray-600">{value.name}</p>
                                    </div>
                                    <div className="col-span-2">
                                        <p className="text-gray-700 font-semibold tracking-wide">{value.value}</p>
                                    </div>
                                </div>
                            </div>
                        )) }

                        
                        
                    </div>

                </div>

                <div className="m-3">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="font-semibold text-purple-700 border-t border-gray-200" onClick={showMore}>Show more</a>
                </div>
            </div>
        </div>
    )
}
